import { useMutation } from '@tanstack/react-query';
import { bulkOnApprovalBankOperation } from 'config/requests/bankOperations';
import { queryClient } from 'providers/queryClient';
import { useNotify } from 'react-admin';

export function useBulkOnApprovalRequestsBankOps() {
  const notify = useNotify();

  const mutation = useMutation({
    mutationFn: ({ ids }: { ids: number[] }) => bulkOnApprovalBankOperation(ids),
    onSuccess: async (_, { ids }) => {
      await queryClient.invalidateQueries({ queryKey: ['bank_operations/pending_statuses'] });

      notify(
        `Заявка на банковскую операцию ID ${ids.join(', ')} переведена в статус На согласовании`,
        {
          type: 'success',
        },
      );
    },
  });

  return { bulkOnApprovalRequestsBankOps: mutation };
}
